<template>
    <v-col cols="12" class="Payment mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
                 <v-row >
                        <v-col>
                            <h2 class="font-weight-medium text-center title-reports my-6">Pago de Servicios Neocity</h2>
                        </v-col>
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#7F03BB"
                                    to="/system/reports/payment"
                            >
                                <v-icon>mdi-cart</v-icon>
                        </v-btn>  
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#FFB12A"
                                    @click="dialog.video = true"
                            >
                                <v-icon>mdi-play</v-icon>
                        </v-btn>  
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#0172C0"
                            >
                                <v-icon>mdi-flash</v-icon>
                        </v-btn>  
                    </v-row>
                        <v-row>
                            <v-col cols="12" class="d-none d-md-block">
                                <v-stepper alt-labels>
                                    <v-stepper-header class="text-center elevation-0">
                                        <v-stepper-step step="1" complete>Selecciona tus productos</v-stepper-step>

                                        <v-divider class="complete"></v-divider>

                                        <v-stepper-step step="2" complete>Selecciona tu medio de pago</v-stepper-step>

                                        <v-divider></v-divider>

                                        <v-stepper-step step="3">Datos de facturación</v-stepper-step>

                                        <v-divider></v-divider>

                                        <v-stepper-step step="4">Términos y condiciones</v-stepper-step>

                                        <v-divider></v-divider>

                                        <v-stepper-step step="5">Realiza tu pago</v-stepper-step>
                                        <v-divider></v-divider>

                                        <v-stepper-step step="6">Comprobante de compra</v-stepper-step>
                                    </v-stepper-header>
                                </v-stepper>
                            </v-col>
                            <v-col cols="12" v-if="errorPayment">
                                <v-row class="align-center" >
                                    <v-col cols="12" lg="2">
                                        <v-icon size="200" color="red">mdi-close-circle-outline</v-icon>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <h2 class="font-weight-medium">oh! Algo salió mal </h2>
                                        <p>Hola <b>Usuario!</b> Algo salió mal en el proceso de pago. Inténtalo nuevamente mas tarde. Si vuelves a tener problemas, no dudes en contactarnos para poder ayudarte.</p>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" lg="8">
                                <h4>Tu selección de servicios</h4>
                                <v-card
                                    class="mx-auto my-3 shadow-1 rounded-lg seleccionServicios"
                            >
                                <v-list-item three-line>
                                    <v-list-item-avatar
                                            tile
                                            size="120"
                                            color=""
                                            class=""
                                    >
                                        <v-col>
                                            <img
                                            src="@/assets/images/reports/ico/report.png"
                                            alt="report 10">
                                        </v-col>
                                    </v-list-item-avatar>
                                        <v-col cols="8">
                                            <h4 class="mb-1">Plan 10 informes  - Análisis de desempeño</h4>
                                            <p>Lorem Ipsum is simply dummy text of the printing<br>
                                                and typesetting industry. Lorem Ipsum has been<br>
                                                the industry's standard </p>
                                        </v-col>
                                        <v-list-item-content class="text-center pr-10">
                                            <v-select
                                                style="height:20px;"
                                                :items="['Plan 10 informes','Plan 5 informes','Plan Acceso ilimitado']"
                                                value="Plan 10 informes"
                                                class="select-color-blue-min"
                                                dense
                                            ></v-select>
                                        </v-list-item-content>
                                            <v-icon>mdi-close</v-icon>
                                    </v-list-item>
                                </v-card>
                                <v-card
                                        class="mx-auto my-3 shadow-1 rounded-lg seleccionServicios"
                                >
                                    <v-list-item three-line>
                                        <v-list-item-avatar
                                                tile
                                                size="120"
                                                color=""
                                                class=""
                                        >
                                            <v-col>
                                                <img
                                                src="@/assets/images/reports/ico/report-5.png"
                                                alt="report 10">
                                            </v-col>
                                        </v-list-item-avatar>
                                        <v-col cols="8">
                                                <h4 class="mb-1">Plan 5 informes  - Consumo Anual Energía</h4>
                                                <p>Lorem Ipsum is simply dummy text of the printing<br>
                                                and typesetting industry. Lorem Ipsum has been<br>
                                                the industry's standard </p>
                                        </v-col>
                                        <v-list-item-content class="text-center pr-10">
                                            <v-select
                                                style="height:20px;"
                                                :items="['Plan 10 informes','Plan 5 informes','Plan Acceso ilimitado']"
                                                value="Plan 5 informes"
                                                dense
                                                class="select-color-blue-min"
                                            ></v-select>

                                        </v-list-item-content>
                                            <v-icon>mdi-close</v-icon>
                                    </v-list-item>
                                </v-card>
                                <v-row>
                                    <v-col cols="12" md="3">
                                            <v-text-field
                                                label="Código de descuento"
                                                placeholder="Ingrese tu código"
                                                filled
                                                dense
                                            ></v-text-field>
                                        
                                    </v-col> 
                                    <v-col cols="12" md="3">
                                        <v-btn color="grey darken-2"
                                        raised
                                        dark
                                        class="pa-6 px-12" style="width:100%; height: 64px;">Validar Código</v-btn></v-col>  
                                </v-row>
                                <h4 class="my-4 mt-8">Selecciona tu medio de pago</h4>
                                <v-row>
                                    <v-col v-for="tc in 13" cols="2" :key="tc+'-tc'" class="ma-0 pa-1">
                                            <v-card outlined class="pa-1" height="57">
                                                <div
                                                        class="py-3 text-center grey lighten-2 rounded-0"
                                                        v-text="`tarjeta`"
                                                ></div>
                                        </v-card>  
                                    </v-col>
                                </v-row>
                                <h4 class="my-4">Paga con tarjetas de casas comerciales</h4>
                                <v-row>
                                    <v-col v-for="tcc in 6" cols="2" :key="tcc+'-tcc'" class="ma-0 pa-1" >
                                        <v-card outlined class="pa-1" height="57">
                                            <div
                                                class="text-center py-3 grey lighten-2 rounded-0"
                                                v-text="`tarjeta`"
                                            ></div>
                                        </v-card>  
                                        
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" lg="4">
                                <h4 class="mb-4">Detalles de la compra</h4>

                                <v-card style="border: 3px solid #2196F3" class="rounded-lg detalleCompra">
                                    <v-card-title>
                                        <v-row class="px-2">
                                            <v-col cols="9">
                                                <h3>
                                                    Análisis de desempeño
                                                </h3>
                                                <p>Suscripción única</p>
                                            </v-col>
                                            <v-col cols="3">
                                                <h2 class="blue--text text-right">
                                                    5UF
                                                </h2>
                                            </v-col>
                                        </v-row>
                                        <v-col cols="12">
                                                <v-divider></v-divider>
                                        </v-col>
                                        <v-row class="px-2">
                                            <v-col cols="9">
                                                <h3>
                                                    Consumo  Anual Energía
                                                </h3>
                                                <p>Suscripción única</p>
                                            </v-col>
                                            <v-col cols="3">
                                                <h2 class="blue--text text-right">
                                                    5UF
                                                </h2>
                                            </v-col>
                                        </v-row>
                                    </v-card-title>
                                    <v-divider class="py-10"></v-divider>
                                    <v-card-text>
                                        <br>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-row class="px-2">
                                            <v-col cols="9">
                                                <h3>
                                                    Total a pagar
                                                </h3>
                                            </v-col>
                                            <v-col cols="3">
                                                <h2 class="blue--text text-right">
                                                    10UF
                                                </h2>
                                                <p  class="blue--text text-right" >49.880 CLP</p>

                                            </v-col>
                                        </v-row>

                                    </v-card-actions>
                                </v-card>
                                <div class="d-flex">
                                    <v-checkbox >
                                </v-checkbox>
                                        <a class="font-size-13 mt-6" href="/system/reports/terms" target="_blank"  >He leido y acepto los terminos y condiciones</a>
                                </div>
                                
                                <v-btn color="green"
                                        raised
                                        dark
                                        to="/system/reports/payment-2"
                                        class="pa-6 px-12" style="width:100%">Siguiente</v-btn>

                                <a href="#" @click="errorPayment = true" >cancelar</a>
                            </v-col>
                        </v-row>
                    
                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>
<style lang="scss">
    .datos-facturacion{
         .v-input{
            .v-input__control{
                font-size: 18px !important;
                .v-text-field__slot{
                     font-size: 18px !important;
                    padding-bottom:6px !important;
                }
        }
     }   
    }
</style>
<script>
    export default {
        name: 'Payment',
        data() {
            return {
                errorPayment:false
            }
        },
        created: function () {
            this.$emit('SetcolorMenu', '#7F03BB');
        }
    }
</script>